export { default, type CardProps } from './Card';
